// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useEffect } from 'react';
import { type ApiError, AppError } from '../errors';
import { useErrorContext } from './ErrorContext';

export const useEmitOnError = (error: ApiError | null) => {
  const { emitError } = useErrorContext();
  useEffect(() => {
    if (error) {
      emitError(new AppError(error));
    }
  }, [error, emitError]);
};
